const styles = {
  oldOfficeStack: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "baseline",
    justifyContent: "space-between",
    padding: "10px 24px",
    gap: "4px"
  },
  oldOfficeText: {
    display: "inline-block",
  },
  arrow: {
    verticalAlign: "middle"
  },
  goNowText: {
    display: "inline-block",
    color: "#153862",
    margin: "0 4px 0 4px"
  },
  button: {
    color: "#000",
    width: "fit-content",
    height: "100%",
    backgroundColor: "#919EAB33",
    borderRadius: "4px",
    padding: "8px",
    "&:hover": {
      backgroundColor: "#919EAB33",
      opacity: ".7"
    }
  },
  disabledButton: {
    color: "#fff",
    backgroundColor: "#919EAB",
    opacity: ".3",
    "&:hover": {
      backgroundColor: "#919EAB",
      cursor: "not-allowed"
    },
  }
};

export default styles;
